
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hts-code/[htsCode]",
      function () {
        return require("private-next-pages/hts-code/[htsCode].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hts-code/[htsCode]"])
      });
    }
  